import { Routes, Route, Navigate } from "react-router-dom";
import PlatformPaymentAccountsPage from "../payment-accounts";
import SupportRequests from "../support/SupportRequests";
import PlatformOrganizations from "../organizations";
import MaintenanceBanners from "../maintenance-banners/MaintenanceBanners";
import ServerTools from "../server-tools/ServerTools";
import NeedsReconciliation from "../needs-reconciliation/NeedsReconciliation";

/**
 * "Platform Settings" sub-shell for the platform super-admin (reached from the top-right menu). Groups the
 * platform-only surfaces — the platform's own Payment Accounts (Plaid gateway from the prior workflow), cross-org
 * Support Request management, Organizations, Maintenance Banners, and Server Tools. Rendered in the content
 * column; its sidebar is `PlatformMenu` (mounted by App.tsx when the path is under /platform-settings).
 */
const PlatformSettings = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="payment-accounts" replace />} />
      <Route path="payment-accounts" element={<PlatformPaymentAccountsPage />} />
      <Route path="support" element={<SupportRequests />} />
      <Route path="organizations/*" element={<PlatformOrganizations />} />
      <Route path="maintenance-banners" element={<MaintenanceBanners />} />
      <Route path="needs-reconciliation" element={<NeedsReconciliation />} />
      <Route path="server-tools" element={<ServerTools />} />
    </Routes>
  );
};

export default PlatformSettings;
